import {
  MarketTypes,
  playerPropsMarkets,
  SportsNameType,
} from "app/utils/const";
import isEmpty from "lodash/isEmpty";
import type { Node } from "React";
import { Component } from "react";
import { marketPeriodHelper } from "../../../../../../../../../helpers/marketPeriodHelper";
import type {
  EventMarketType,
  EventType,
} from "../../../../../../../../../types/eventType";
import BinaryMarketTypeSubheading from "./components/BinaryMarketTypeSubheading/BinaryMarketTypeSubheading";
import BlankMarketTypeSubheading from "./components/BlankMarketTypeSubheading/BlankMarketTypeSubheading";
import CorrectScoreMarketTypeSubheading from "./components/CorrectScoreMarketTypeSubheading/CorrectScoreMarketTypeSubheading";
import OverUnderSubheading from "./components/OverUnderSubheading/OverUnderSubheading";
import TeamsMarketTypeSubheading from "./components/TeamsMarketTypeSubheading/TeamsMarketTypeSubheading";
import ThreeWayMarketTypeSubheading from "./components/ThreeWayMarketTypeSubheading/ThreeWayMarketTypeSubheading";
import TwoWayMarketTypeSubheading from "./components/TwoWayMarketTypeSubheading/TwoWayMarketTypeSubheading";
import "./MarketSubHeadings.scss";
import PlayerPropsSubHeading from "./PlayerPropsSubHeading/PlayerPropsSubHeading";
type Props = {
  market: EventMarketType;
  marketType: Record<string, any>;
  event: EventType;
};

class MarketSubHeadings extends Component<Props> {
  render(): null | Node {
    const { market, marketType, event } = this.props;
    const twoWaySubHeadingMarketTypes = [
      MarketTypes.PLAYER_SCORE_OUTSIDE_AREA,
      MarketTypes.PLAYER_ASSISTS,
      MarketTypes.PLAYER_ASSISTS_2_PLUS,
      MarketTypes.PLAYER_SCORE_AND_ASSIST,
      MarketTypes.PLAYER_SCORE_FREEKICK,
      MarketTypes.PLAYER_SCORE_HEADER,
      MarketTypes.PLAYER_SHOWN_CARD,
      MarketTypes.PLAYER_SHOWN_RED_CARD,
      MarketTypes.TOUCHDOWN_SCORER_ANYTIME,
      MarketTypes.PLAYER_TOUCHDOWN_2_PLUS,
    ];
    // Add all PlayerProp MarketTypes here for the subheader to be shown
    // subheader(s) for NFL, NBA
    const playerpropsSubHeadingstypes = [
      MarketTypes.PLAYER_TOTAL_RUSHING_YARDS_ROLLING,
      MarketTypes.PLAYER_TOTAL_RUSHING_ATTEMPTS_ROLLING,
      MarketTypes.PLAYER_TOTAL_RECEIVING_YARDS_ROLLING,
      MarketTypes.PLAYER_TOTAL_RECEPTIONS_ROLLING,
      MarketTypes.PLAYER_TOTAL_PASSING_YARDS_ROLLING,
      MarketTypes.PLAYER_TOTAL_PASSING_ATTEMPTS_ROLLING,
      MarketTypes.PLAYER_TOTAL_PASS_COMPLETIONS_ROLLING,
      MarketTypes.PLAYER_TOTAL_PASSING_TOUCHDOWNS_ROLLING,
      MarketTypes.PLAYER_TOTAL_POINTS_ROLLING,
      MarketTypes.PLAYER_TOTAL_ASSISTS_ROLLING,
      MarketTypes.PLAYER_TOTAL_BLOCKS_ROLLING,
      MarketTypes.PLAYER_TOTAL_REBOUNDS_ROLLING,
      MarketTypes.PLAYER_TOTAL_STEALS_ROLLING,
    ];

    // ARCH-85
    if (!isEmpty(market.runners) && !isEmpty(marketType)) {
      if (twoWaySubHeadingMarketTypes.includes(marketType.marketType)) {
        return <TwoWayMarketTypeSubheading event={event} market={market} />;
      } else if (playerPropsMarkets.includes(marketType.marketType)) {
        return <PlayerPropsSubHeading event={event} market={market} />;
      } else if (
        marketType.marketType === MarketTypes.WINNING_MARGIN ||
        marketType.marketType === MarketTypes.FIRST_LAST_GOAL ||
        marketType.marketType === MarketTypes.ONE_X_TWO ||
        marketType.marketType === MarketTypes.RACE_TO ||
        market.type.indexOf("GOALSCORER") > -1 ||
        marketType.marketType.includes("TOUCHDOWN_SCORER")
      ) {
        return (
          <ThreeWayMarketTypeSubheading
            event={event}
            market={market}
            columnType={marketPeriodHelper.getGroupValue(marketType.marketType)}
          />
        );
      } else if (
        marketType.marketType === MarketTypes.HANDICAP ||
        marketType.marketType === MarketTypes.SET_HANDICAP ||
        marketType.marketType === MarketTypes.MONEY_LINE ||
        marketType.marketType === MarketTypes.CORNER_HANDICAP ||
        marketType.marketType === MarketTypes.CORNER_TOTAL ||
        marketType.marketType === MarketTypes.HANDICAP_KILLS ||
        marketType.marketType === MarketTypes.MOST_KILLS
      ) {
        return <BinaryMarketTypeSubheading markets={marketType.markets} />;
      } else if (marketType.marketType === MarketTypes.CORRECT_SCORE) {
        if (event.sportType === SportsNameType.TENNIS) {
          return <TeamsMarketTypeSubheading event={event} />;
        } else {
          return (
            <CorrectScoreMarketTypeSubheading event={event} market={market} />
          );
        }
      } else if (
        marketType.marketType === MarketTypes.TOTAL ||
        marketType.marketType === MarketTypes.SET_TOTAL ||
        marketType.marketType === MarketTypes.THREE_WAY_AND_TOTAL ||
        marketPeriodHelper.getDisplayType(marketType.marketType) === 1
      ) {
        return <OverUnderSubheading market={market} />;
      } else if (
        marketType.marketType === MarketTypes.THREE_WAY_AND_BOTH_SCORE ||
        marketType.marketType === MarketTypes.CLEAN_SHEET ||
        marketType.marketType === MarketTypes.WIN_TO_NIL ||
        marketType.marketType === MarketTypes.BOTH_SCORE ||
        marketType.marketType === MarketTypes.MATCH_TIE ||
        marketType.marketType === MarketTypes.BOTH_SCORE_AND_TOTAL
      ) {
        return null;
      } else if (
        marketPeriodHelper.getDisplayType(marketType.marketType) === 8 ||
        marketType.marketType === MarketTypes.CORNER_ONE_X_TWO ||
        (marketPeriodHelper.getDisplayType(marketType.marketType) === 6 &&
          marketType.marketType !== MarketTypes.CLEAN_SHEET) ||
        marketType.marketType !== MarketTypes.WIN_TO_NIL ||
        marketType.marketType !== MarketTypes.BOTH_SCORE
      ) {
        return null;
      }
    }

    return <BlankMarketTypeSubheading />;
  }
}

export default MarketSubHeadings;
